import React, {Component} from "react"
import AutoLoaderDeviceOverviewContextProvider from "./context/AutoLoaderDeviceOverviewContext";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import Column from "@amzn/meridian/column";
import { AUTO_LOADER} from "../../util/RouteConstants";


/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AutoLoaderDevicePage extends Component{
    render() {

        return (
            <Column>
                <AutoLoaderDeviceOverviewContextProvider>
                    <TabLayout routes={AUTO_LOADER} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={AUTO_LOADER}/>
                </AutoLoaderDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AutoLoaderDevicePage;


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/AutoLoaderDevicePage.js